/**
 * Component Registry for Ventura Lofts Apartments
 *
 * Inherits from @vibesites-rr-living-landing-page/theme-landing-page and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-rr-living-landing-page/theme-landing-page/registry';
import { Hero } from './components/Hero';
import { PropertyOverview } from './components/PropertyOverview';
import { CTASection } from './components/CTASection';
import { FloorPlansList } from './components/FloorPlansList';

/**
 * Property-specific component overrides emphasizing spacious floor plans.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
  PropertyOverview,
  CTASection,
  FloorplansList: FloorPlansList,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
